import React, { useState, useEffect } from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface ComingSoonProps {
  title?: string;
  subtitle?: string;
  showCountdown?: boolean;
  launchDate?: string;
}

export default function ComingSoon({
  title,
  subtitle,
  showCountdown = true,
  launchDate = "2025-12-31T00:00:00Z"
}: ComingSoonProps) {
  const { t } = useTranslation('common');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    if (!showCountdown) return;

    const calculateTimeLeft = () => {
      const difference = +new Date(launchDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [launchDate, showCountdown]);

  return (
    <div className="coming-soon-wrapper">
      <div className="coming-soon-container">
        <div className="coming-soon-content">
         

          {/* Title */}
          <h1 className="coming-soon-title">
            {title || "Coming Soon"}
          </h1>

          {/* Subtitle */}
          <p className="coming-soon-subtitle">
            {subtitle || "We're working hard to bring you something amazing. Stay tuned!"}
          </p>

          {/* Countdown Timer */}
          {showCountdown && (
            <div className="countdown-container">
              <h3 className="countdown-label">Launch in:</h3>
              <div className="countdown-timer">
                <div className="countdown-item">
                  <span className="countdown-number">{timeLeft.days}</span>
                  <span className="countdown-text">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">{timeLeft.hours}</span>
                  <span className="countdown-text">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">{timeLeft.minutes}</span>
                  <span className="countdown-text">Minutes</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">{timeLeft.seconds}</span>
                  <span className="countdown-text">Seconds</span>
                </div>
              </div>
            </div>
          )}

          

          
        </div>

        {/* Background Animation */}
        <div className="coming-soon-bg-animation">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
          <div className="floating-shape shape-4"></div>
          <div className="floating-shape shape-5"></div>
        </div>
      </div>
    </div>
  );
}